import { DeleteOutlined } from '@ant-design/icons';
import { TechnicalCategoryBookmark } from '@services';
import { Button, Col, Divider, Row } from 'antd';
import React, { Fragment } from 'react';

interface IProps {
  bookmarks: TechnicalCategoryBookmark[];
  onBookmarkClick: (id: string) => void;
  onRemoveBookmarkClick: (id: string) => void;
}

const TechnicalCategoryBookmarkMenu: React.FC<IProps> = ({
  bookmarks,
  onBookmarkClick,
  onRemoveBookmarkClick,
}) => {
  return (
    <>
      {bookmarks.map((bookmark) => (
        <Fragment key={bookmark.id}>
          <Row>{bookmark.technicalCategory.category}</Row>
          <Row justify="space-between">
            <Col span={18}>
              <Button
                style={{ textAlign: 'left', whiteSpace: 'break-spaces' }}
                type="text"
                onClick={() => onBookmarkClick(bookmark.technicalCategoryId)}
              >
                {bookmark.technicalCategory.name}
              </Button>
            </Col>
            <Col>
              <Button
                type="text"
                icon={<DeleteOutlined />}
                onClick={() => onRemoveBookmarkClick(bookmark.id)}
              />
            </Col>
          </Row>
          <Divider />
        </Fragment>
      ))}
    </>
  );
};

export default TechnicalCategoryBookmarkMenu;
